export default __webpack_public_path__ + "0489d4875c7037306b615c840f4a6fbd.jpg";